import axios from "../utils/axios";

// Send StoreLogs
export const sendStoreLogs = async (req) => {
    try {
        const { data } = await axios.post('/user/store-logs', req, {
            headers: { 'Accept': 'application/json', },
        });
        return data;
    } catch (error) {
        console.error("🚀 ~ createStore ~ error:", error);
        throw error;
    }
};